
import { Component, Vue } from "vue-property-decorator";
import RecruitHeader from "./c-components/recruit-header.vue";
import RecruitCategory from "./c-components/recruit-category.vue";
import RecruitCategoryDetail from "./c-components/recruit-category-detail.vue";

@Component({
  components: {
    RecruitHeader,
    RecruitCategory,
    RecruitCategoryDetail,
  },
})
export default class Recruit extends Vue {}
